import { store } from '../store'

export default class WidgetTypeService {
    async getWidgetTypes (params) {
        return await store.dispatch('widgetType/getWidgetTypes', {
            _data: params
        })
    }
}
